module.exports = __webpack_public_path__ + "unwrap.svg?486a9368998b2b5c17cc1e2e0952f7cb";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/unwrap.svg
// module id = 252
// module chunks = 0